import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { SignInType } from "@portal/app/login/SignInFlowController";
import { captureException } from "@sentry/nextjs";
import AppleSignin, { AppleAuthResponse } from "react-apple-signin-auth";

const clientId = process.env.APPLE_CLIENT_ID;
const redirectURI = `${process.env.DREAM_PORTAL_URL}/api/auth/apple`;

export const AppleAuth = ({
  onSuccess,
  onError,
  propsToContainer,
  signInType,
}: {
  onSuccess: (response: AppleAuthResponse) => void;
  onError?: (error: unknown) => void;
  propsToContainer?: React.ComponentProps<typeof Box>;
  signInType?: SignInType;
}) => {
  if (!clientId || !redirectURI) return null;

  return (
    <AppleSignInContainer {...propsToContainer}>
      <AppleSignin
        authOptions={{
          clientId,
          scope: "name email",
          redirectURI,
          state: undefined, // Optionally pass state
          usePopup: true,
        }}
        uiType="light"
        className="apple-auth-btn"
        onSuccess={onSuccess}
        onError={(error: unknown) => {
          void captureException(error);
          return onError?.(error);
        }}
        buttonExtraChildren={
          signInType === "CREATE_ACCOUNT" ? "Sign up with Apple" : "Sign in with Apple"
        }
        // We're allowed to pass button props down (since they are spread to the
        // underlying button)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        style={{
          width: "100%",
        }}
      />
    </AppleSignInContainer>
  );
};

const AppleSignInContainer = styled(Box)`
  width: 100%;
`;
